import React from 'react';
import { Users, Target, Trophy } from 'lucide-react';
import { ParallaxImage } from '../ui/ParallaxImage';
export function About() {
  return <section id="about" className="py-24 bg-prt-darker relative" data-id="element-34">
      <div className="container mx-auto px-6" data-id="element-35">
        <div className="grid lg:grid-cols-[60%_40%] gap-12 lg:gap-20 items-center" data-id="element-36">
          <div data-id="element-37">
            <h2 className="font-heading text-white text-4xl md:text-6xl leading-tight mb-6" data-id="element-38">
              WE ARE A COMMUNITY
              <br data-id="element-39" />
              OF AWESOMENESS.
            </h2>
            <p className="text-prt-muted text-lg mb-8 leading-relaxed" data-id="element-40">
              Located in Gilbert, AZ, PRT isn't your typical big-box gym. We
              believe in surrounding yourself with like-minded, driven people
              who push you further than you'd ever go alone. When you walk
              through our doors, you're not just renting equipment—you're
              joining a family that demands your best and supports you every
              step of the way.
            </p>

            <div className="flex flex-col sm:flex-row gap-8 mt-12" data-id="element-41">
              <div className="flex items-center gap-4" data-id="element-42">
                <div className="w-12 h-12 rounded-full bg-prt-blue/10 flex items-center justify-center text-prt-blue shrink-0" data-id="element-43">
                  <Users size={24} data-id="element-44" />
                </div>
                <span className="text-white font-heading text-xl tracking-wide" data-id="element-45">
                  Community
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-46">
                <div className="w-12 h-12 rounded-full bg-prt-blue/10 flex items-center justify-center text-prt-blue shrink-0" data-id="element-47">
                  <Target size={24} data-id="element-48" />
                </div>
                <span className="text-white font-heading text-xl tracking-wide" data-id="element-49">
                  Accountability
                </span>
              </div>
              <div className="flex items-center gap-4" data-id="element-50">
                <div className="w-12 h-12 rounded-full bg-prt-blue/10 flex items-center justify-center text-prt-blue shrink-0" data-id="element-51">
                  <Trophy size={24} data-id="element-52" />
                </div>
                <span className="text-white font-heading text-xl tracking-wide" data-id="element-53">
                  Results
                </span>
              </div>
            </div>
          </div>

          <div className="relative h-[500px] rounded-lg overflow-hidden border-l-4 border-prt-blue" data-id="element-54">
            <ParallaxImage src="https://images.unsplash.com/photo-1518310383802-640c2de311b6?q=80&w=2070&auto=format&fit=crop" alt="Group HIIT class training together" className="w-full h-full" overlay={false} data-id="element-55" />
          </div>
        </div>
      </div>
    </section>;
}